import { findVirtualBrands } from '~/Api/Analytics/Autocomplete/VirtualBrand';
import { invokeApi, tryResolve } from '~/ApiClient';
import { ThunkAction } from '~/Store';

import ActionTypes from './ActionTypes';
import { selectBrands, State } from './reducer';

export function loadBrands(filter: string): ThunkAction<Promise<void>, any> {
	return async (dispatch, getState) => {
		const normalizedFilter = filter.slice(0, 1);
		const brands = selectBrands(getState().medicinalBrandsAnalyticsBrandAutocomplete, normalizedFilter);
		await (brands || dispatch(fetchBrands(normalizedFilter)));
	};
}

export function fetchBrands(filter: string): ThunkAction<Promise<void>, any> {
	return async (dispatch) => {
		const request = dispatch(invokeApi(findVirtualBrands, filter));
		dispatch({ type: ActionTypes.request, request, filter });
		tryResolve(request, (response) =>
			dispatch({
				type: ActionTypes.receive,
				request,
				filter,
				items: response?.items,
			})
		);
	};
}
